import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';

@Component({
    standalone: true,
    selector: 'sirius-spacer',
    template: `<div class="sir-spacer"><ng-content></ng-content></div>`,
    styleUrls: ['./spacer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpacerComponent implements IDynamicElement {}
